module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-ace.845dae03.svg";